import { styled } from "@linaria/react";

import FlexItem from "@gx/dls/containers/FlexItem";
import FlexWrapper, { AlignItems, FlexDirection } from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

import type { FileUploadProgress } from "@/pages/sources/components/create/sources/types";
import DropzoneWidgetTableHeader from "@/pages/sources/components/dropzone/DropzoneWidgetTableHeader";
import DropzoneWidgetTableRow from "@/pages/sources/components/dropzone/DropzoneWidgetTableRow";

const DropzoneWidgetTableWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`);

export interface DropzoneWidgetTableProps {
  files: File[];
  onRemoveFile: (index: number) => void;
  isDisabled?: boolean;
  fileProgressMap?: Map<string, FileUploadProgress>;
}

const DropzoneWidgetTable = ({
  files,
  onRemoveFile,
  isDisabled = false,
  fileProgressMap,
}: DropzoneWidgetTableProps) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <DropzoneWidgetTableWrapper>
      <FlexItem shrink={0} fillWidth display="block">
        <DropzoneWidgetTableHeader />
        <HorizontalDivider />
      </FlexItem>
      <FlexItem grow={1} overflow="auto" minHeight={0}>
        <FlexWrapper
          direction={FlexDirection.COLUMN}
          alignItems={AlignItems.CENTER}
          gap={0}
          fillWidth
        >
          {files.map((file, index) => (
            <DropzoneWidgetTableRow
              key={`${file.name}-${index}`}
              file={file}
              index={index}
              onRemoveFile={onRemoveFile}
              isDisabled={isDisabled}
              progress={fileProgressMap?.get(file.name)}
            />
          ))}
        </FlexWrapper>
      </FlexItem>
    </DropzoneWidgetTableWrapper>
  );
};

export default DropzoneWidgetTable;
